import { Translate } from 'next-translate'

import { SuggestedCriteria } from '@/lib/api-gluglu-auth'
import { fetchReferenceAreaByCityGeoSlug } from '@/page-commons/citiesQuery'

import { formatPrice } from './format-currency'

export type CriteriaWithReferenceArea = SuggestedCriteria & { referenceArea: string }

export const getReferenceAreaByGeoSlug = (geoSlugs: string[]) => {
  const [firstSlug] = geoSlugs
  const splittedSlug = firstSlug.split('/')
  if (splittedSlug.length === 3) {
    return splittedSlug.slice(0, splittedSlug.length - 1).join('/')
  }
  const foundReferenceArea = fetchReferenceAreaByCityGeoSlug(firstSlug)
  if (!foundReferenceArea) return null
  return foundReferenceArea.referenceArea
}

export const getRoomsMinOptions = (t: Translate, isPlural?: boolean) => {
  const count = isPlural ? 2 : 1
  return [
    { text: t('suggested:Suggested_Flow_HouseType_1room', { count }), value: '1' },
    { text: t('suggested:Suggested_Flow_HouseType_2room', { count }), value: '2' },
    { text: t('suggested:Suggested_Flow_HouseType_3room', { count }), value: '3' },
    { text: t('suggested:Suggested_Flow_HouseType_4room', { count }), value: '4' },
    { text: t('suggested:Suggested_Flow_HouseType_5orMore', { count }), value: '5' },
  ]
}

export const getRoomsMinLabel = (t: Translate, roomsMin: number, isPlural?: boolean) => {
  const roomsMinOptions = getRoomsMinOptions(t, isPlural)
  return roomsMinOptions.find((item) => Number(item.value) === roomsMin)?.text ?? roomsMinOptions.at(-1).text
}

export const getBudgetFromCriteria = (lang: Locale, budget: number) =>
  formatPrice(
    {
      cents: budget * 100,
    },
    lang
  )
